import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer, BackTop } from "./Footer";
import { HeadCode } from "./AdSlot";
import { track } from "../lib/analytics";

export default function Layout() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  useEffect(() => {
    // wait for the page to set its title before sending the page view
    const t = setTimeout(() => track("page_view", { page_location: window.location.href, page_title: document.title }), 700);
    return () => clearTimeout(t);
  }, [pathname, search]);
  return (
    <>
      <HeadCode />
      <Header />
      <div className="gamemonetize-page-tree gamemonetize-container">
        <Outlet />
      </div>
      <Footer />
      <BackTop />
    </>
  );
}
